import { render } from "./BizScene.vue?vue&type=template&id=b54cadd4"
import script from "./BizScene.vue?vue&type=script&lang=js"
export * from "./BizScene.vue?vue&type=script&lang=js"

import "./BizScene.vue?vue&type=style&index=0&id=b54cadd4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__